import { useState, useEffect, useCallback } from 'react';

import { loadInventory } from 'src/utils/Services/inventory-loader';

import { useDeviceSyncStore } from 'src/store/DeviceSync';
import { getSessionGeneration, isSessionGenerationCurrent } from 'src/auth/session-lifecycle';

export function useInventoryData(enabled = true) {
  const businessId = useDeviceSyncStore((state) => state.businessData?.id);
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState<{ businessId?: string; ready: boolean; error: string | null }>(
    {
      ready: false,
      error: null,
    }
  );
  const retry = useCallback(() => setAttempt((value) => value + 1), []);

  useEffect(() => {
    if (!enabled || !businessId) return undefined;
    let stopped = false;
    const generation = getSessionGeneration();
    setState((previous) => ({
      businessId,
      ready: previous.businessId === businessId && previous.ready,
      error: null,
    }));
    loadInventory(businessId)
      .then(() => {
        if (!stopped && isSessionGenerationCurrent(generation))
          setState({ businessId, ready: true, error: null });
      })
      .catch(() => {
        if (!stopped && isSessionGenerationCurrent(generation))
          setState((previous) => ({
            businessId,
            ready: previous.businessId === businessId && previous.ready,
            error: 'Unable to load the menu. Check the connection and try again.',
          }));
      });
    return () => {
      stopped = true;
    };
  }, [businessId, enabled, attempt]);

  const ready = Boolean(businessId && state.businessId === businessId && state.ready);
  const error = state.businessId === businessId ? state.error : null;
  return { ready, loading: enabled && !ready && !error, error, retry };
}
